import { FaDatabase, FaServer, FaUserAlt, FaUserShield } from "react-icons/fa";
import { GiWorld } from "react-icons/gi";
import { LuTicketCheck } from "react-icons/lu";
import { MdGroups } from "react-icons/md";
import { RiLockPasswordLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import images from "./images";
import { TbCertificate } from "react-icons/tb";
import { RiCloudLine } from "react-icons/ri";
import GoogleCloudLogo from "../images/google-cloud_logo.png";
import AzureLogo from "../images/ResourceIcons/azure.svg";
import AWSLogo from "../images/AWS.svg";
export const resourceListCards = [
  {
    id: 1,
    title: "MySQL",
    description: "Database",
    imageURL: images.mysql,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/mysql",
  },
  {
    id: 2,
    title: "PostgreSQL",
    description: "Database",
    imageURL: images.pssql,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/postgreSQL",
  },
  {
    id: 3,
    title: "MSSQL",
    description: "Database",
    imageURL: images.mssql,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/mssql",
  },
  {
    id: 4,
    title: "OracleDB",
    description: "Database",
    imageURL: images.oracle,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/oracledb",
  },
  {
    id: 5,
    title: "SaphanaDB",
    description: "Database",
    imageURL: images.sap,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/sapHanadb",
  },
  {
    id: 6,
    title: "Linux",
    description: "Server",
    imageURL: images.linux,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/ssh",
  },
  {
    id: 7,
    title: "Window",
    description: "Server",
    imageURL: images.windows,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/rdp",
  },

  {
    id: 8,
    title: "Kubernetes",
    description: "Server",
    imageURL: images.kubernetes,
    resource_type: "server",
    link: "/dashboard/resources/apps/add-apps/kubernetes",
  },
  {
    id: 9,
    title: "VNC",
    description: "Server",
    imageURL: images.vnc,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/vnc",
  },
  {
    id: 10,
    title: "Go Daddy",
    description: "Web Application",
    imageURL: images.GoDaddy,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/go-daddy",
  },
  {
    id: 11,
    title: "AWS",
    description: "Web Application",
    imageURL: images.AWS,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/aws",
  },
  {
    id: 12,
    title: "Microsoft Office",
    description: "Web Application",
    imageURL: images.microsoftOffice,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/microsoft-office",
  },
  {
    id: 13,
    title: "JIRA",
    description: "Web Application",
    imageURL: images.JIRA,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/jira",
  },
  {
    id: 14,
    title: "Azure",
    description: "Web Application",
    imageURL: images.AzureWebapp,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/azure",
  },
  {
    id: 15,
    title: "Slack",
    description: "Web Application",
    imageURL: images.slack,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/slack",
  },
  {
    id: 16,
    title: "Custom",
    description: "Web Application",
    imageURL: images.customWebApp,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add",
  },
  {
    id: 17,
    title: "Command Prompt",
    description: "Desktop Application",
    imageURL: images.cmd,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/cmd",
  },
  {
    id: 18,
    title: "Notepad",
    description: "Desktop Application",
    imageURL: images.notepad,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/notepad",
  },
  {
    id: 19,
    title: "Remote Desktop",
    description: "Desktop Application",
    imageURL: images.rdp,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/rdp",
  },
  {
    id: 20,
    title: "Media Player",
    description: "Desktop Application",
    imageURL: images.windows_media_player,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/media-player",
  },
  {
    id: 21,
    title: "Paint",
    description: "Desktop Application",
    imageURL: images.paint,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/paint",
  },
  {
    id: 22,
    title: "Powershell",
    description: "Desktop Application",
    imageURL: images.powershell,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/powershell",
  },
  {
    id: 23,
    title: "Registry Editor",
    description: "Desktop Application",
    imageURL: images.registry_editor,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/registry-editor",
  },
  {
    id: 24,
    title: "File Explorer",
    description: "Desktop Application",
    imageURL: images.file_explorer,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/file-explorer",
  },
  {
    id: 25,
    title: "Control Panel",
    description: "Desktop Application",
    imageURL: images.control_panel,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/control-panel",
  },
  {
    id: 26,
    title: "Microsoft Edge",
    description: "Desktop Application",
    imageURL: images.microsoft_edge,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/microsoft-edge",
  },
  {
    id: 27,
    title: "SFTP",
    description: "Server",
    imageURL: images.sftp,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/sftp",
  },
  {
    id: 28,
    title: "SMB",
    description: "Server",
    imageURL: images.smb,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/smb",
  },
  {
    id: 29,
    title: "Custom",
    description: "Desktop Application",
    imageURL: images.customWebApp,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application",
  },
  {
    id: 30,
    title: "Application Credentials",
    description: "Application Credentials",
    imageURL: images.customWebApp,
    resource_type: "application_credentials",
    link: "/dashboard/resources/assets/add-assets/application-credentials/api",
  },
];

export const ReportCardsData = () => {
  const capabilities = useSelector(
    (state) => state.user?.user?.role?.capabilities || {}
  );
  const isCapable = "is_admin_user" in capabilities ? capabilities : false;
  const reports = [
    isCapable &&
      isCapable.report.apps_report && {
        id: 1,
        title: "Databases Report",
        description: "Detailed information about databases report",
        imageComponent: (
          <FaDatabase color="#E04958" size={22} className="m-2" />
        ),
        color: "#FFFAE1",
        link: "/audit-dashboard/reports/databases-report",
      },
    isCapable &&
      isCapable.report.apps_access_report && {
        id: 2,
        title: "Databases Access Report",
        description: "Detailed information about databases access report",
        color: "#FFFAE1",
        imageComponent: (
          <FaDatabase color="#E04958" size={22} className="m-2" />
        ),
        link: "/audit-dashboard/reports/databases-access-report",
      },
    isCapable &&
      isCapable.report.apps_allocation_report && {
        id: 3,
        title: "Databases Allocation Report",
        description: "Detailed information about databases allocation report",
        color: "#FFFAE1",
        imageComponent: (
          <FaDatabase color="#E04958" size={22} className="m-2" />
        ),
        link: "/audit-dashboard/reports/databases-allocation-report",
      },
    isCapable &&
      isCapable.report.assets_report && {
        id: 4,
        title: "Servers Report",
        description: "Detailed information about servers report",
        color: "#EBFCF6",
        imageComponent: <FaServer color="#30E1AB" size={23} />,
        link: "/audit-dashboard/reports/servers-report",
      },
    isCapable &&
      isCapable.report.assets_access_report && {
        id: 5,
        title: "Servers Access Report",
        description: "Detailed information about servers access report",
        color: "#EBFCF6",
        imageComponent: <FaServer color="#30E1AB" size={23} />,
        link: "/audit-dashboard/reports/servers-access-report",
      },
    isCapable &&
      isCapable.report.assets_allocation_report && {
        id: 6,
        title: "Servers Allocation Report",
        description: "Detailed information about servers allocation report",
        color: "#EBFCF6",
        imageComponent: <FaServer color="#30E1AB" size={23} />,
        link: "/audit-dashboard/reports/servers-allocation-report",
      },
    isCapable &&
      isCapable.report.web_apps_report && {
        id: 7,
        title: "Web Apps Report",
        description: "Detailed information about web apps report",
        color: "#E7E9F8",
        imageComponent: <GiWorld color="#6367f9" size={25} />,
        link: "/audit-dashboard/reports/web-apps-report",
      },
    isCapable &&
      isCapable.report.web_apps_access_report && {
        id: 8,
        title: "Web Apps Access Report",
        description: "Detailed information about web apps access report",
        color: "#E7E9F8",
        imageComponent: <GiWorld color="#6367f9" size={25} />,
        link: "/audit-dashboard/reports/web-apps-access-report",
      },
    isCapable &&
      isCapable.report.webapps_allocation_report && {
        id: 9,
        title: "Web Apps Allocation Report",
        description: "Detailed information about web apps allocation report",
        color: "#E7E9F8",
        imageComponent: <GiWorld color="#6367f9" size={25} />,
        link: "/audit-dashboard/reports/web-apps-allocation-report",
      },
    isCapable &&
      isCapable.report.ticket_report && {
        id: 10,
        title: "Tickets Report",
        description: "Detailed information about tickets report",
        color: "#FFE8E8",
        imageComponent: <LuTicketCheck size={23} />,
        link: "/audit-dashboard/reports/tickets-report",
      },
    isCapable.report?.users_report && {
      id: 11,
      title: "Users Report",
      description: "Detailed information about users report",
      color: "#FEF1EB",
      imageComponent: <FaUserAlt color="#F56A3F" size={19} />,
      link: "/audit-dashboard/reports/users-report",
    },
    isCapable &&
      isCapable.report.user_login_report && {
        id: 12,
        title: "Users login Report",
        description: "Detailed information about users login report",
        color: "#FEF1EB",
        imageComponent: <FaUserAlt color="#F56A3F" size={19} />,
        link: "/audit-dashboard/reports/users-login-report",
      },
    isCapable &&
      isCapable.report.roles_report && {
        id: 13,
        title: "Roles Report",
        description: "Detailed information about roles report",
        color: "#FEF1EB",
        imageComponent: <FaUserAlt color="#F56A3F" size={19} />,
        link: "/audit-dashboard/reports/roles-report",
      },
    isCapable &&
      isCapable.report.groups_report && {
        id: 14,
        title: "Groups Report",
        description: "Detailed information about groups report",
        color: "#FEF1EB",
        imageComponent: <MdGroups color="#F56A3F" size={25} />,
        link: "/audit-dashboard/reports/groups-report",
      },
    isCapable.report?.systemuser_report && {
      id: 15,
      title: "System Users Report",
      description: "Detailed information about system users report",
      color: "#E7E9F8",
      imageComponent: <FaUserShield color="#6367F9" size={23} />,
      link: "/audit-dashboard/reports/system-users-report",
    },
    isCapable &&
      isCapable.report.system_user_password_rotation_report && {
        id: 16,
        title: "System Users Password Rotation Report",
        description:
          "Detailed information about system users password rotation report",
        color: "#E7E9F8",
        imageComponent: <FaUserShield color="#6367F9" size={23} />,
        link: "/audit-dashboard/reports/system-users-password-rotation-policy-report",
      },
      isCapable  && isCapable.report.certificate_report && {
        id: 20,
        title: "Certificate Report",
        description: "Detailed information about certificate report",
        color: "#E7E9F8",
        imageComponent: <TbCertificate size={23} color="#6367F9" />,
        link: "/audit-dashboard/reports/certificate-report",
      },
    isCapable &&
      isCapable.report.password_rotation_policy_report && {
        id: 17,
        title: "Passwords Rotation Policy Report",
        description:
          "Detailed information about passwords rotation policy report",
        color: "#e2ffe1",
        imageComponent: <RiLockPasswordLine size={23} />,
        link: "/audit-dashboard/reports/passwords-rotation-policy-report",
      },
    isCapable &&
      isCapable.report.client_credential_report && {
        id: 18,
        title: "Client Credentials Report",
        description: "Detailed information about client credentials report",
        color: "#e2ffe1",
        imageComponent: <RiLockPasswordLine size={23} />,
        link: "/audit-dashboard/reports/client-credentials-report",
      },
    isCapable &&
      isCapable.report.client_credential_report && {
        id: 19,
        title: "Client Credentials Usage Report",
        description: "Detailed information about client credentials usage report",
        color: "#e2ffe1",
        imageComponent: <RiLockPasswordLine size={23} />,
        link: "/audit-dashboard/reports/client-credentials-usage-report",
      },
    isCapable &&
      isCapable.report?.cloud_discovery_report && {
        id: 21,
        title: "Cloud Discovery Config Report",
        description: "Detailed information about cloud discovery configuration operations",
        color: "#E7F3FF",
        imageComponent: <RiCloudLine color="#5177FF" size={23} />,
        link: "/audit-dashboard/reports/cloud-discovery-config-report",
      },
    isCapable &&
      isCapable.report?.cloud_discovery_report && {
        id: 22,
        title: "Cloud Discovery Scan Report",
        description: "Detailed information about cloud discovery scan operations",
        color: "#E7F3FF",
        imageComponent: <RiCloudLine color="#5177FF" size={23} />,
        link: "/audit-dashboard/reports/cloud-discovery-scan-report",
      },
    isCapable &&
      isCapable.report?.cloud_discovery_report && {
        id: 23,
        title: "Cloud Discovery Onboard Report",
        description: "Detailed information about cloud discovery resource onboarding operations",
        color: "#E7F3FF",
        imageComponent: <RiCloudLine color="#5177FF" size={23} />,
        link: "/audit-dashboard/reports/cloud-discovery-onboard-report",
      },
    isCapable && isCapable.report.credentials_checkout_report && {
        id: 20,
        title: "Credential Action Report",
        description: "Detailed information about credential access and actions",
        imageComponent: (
          <RiLockPasswordLine color="#E04958" size={22} className="m-2" />
        ),
        color: "#FFFAE1",
        link: "/audit-dashboard/reports/credential-action-report",
      },
       isCapable && isCapable.report.application_credentials_access_report && {
        id: 21,
        title: "Application Credentials Access Report",
        description: "Detailed information about application credentials access report",
        imageComponent: (
          <RiLockPasswordLine color="#E04958" size={22} className="m-2" />
        ),
        color: "#FFFAE1",
        link: "/audit-dashboard/reports/application-credentials-access-report",
      },
      isCapable && isCapable.report.application_credentials_allocation_report && {
        id: 22,
        title: "Application Credentials Allocation Report",
        description: "Detailed information about application credentials allocation report",
        imageComponent: (
          <RiLockPasswordLine color="#E04958" size={22} className="m-2" />
        ),
        color: "#FFFAE1",
        link: "/audit-dashboard/reports/application-credentials-allocation-report",
      },
  ].filter(Boolean);
  return reports;
};

export const CloudConfigurationData = () => {
  const cards = [
    {
      id:1,
      beta: true, 
      title: "Amazon Web Services",
      description: "Discover resources in your AWS accounts.",
      imageURL: AWSLogo,
      link:
        "/dashboard/discovery/cloudconfiguration/add-cloudconfiguration?provider=aws",
      
    },
    {
      id: 2,
      title: "Google Cloud Provider",
      commingsoon:true,
      description: "Discover resources in your Google Cloud projects.",
      imageURL: GoogleCloudLogo,
      link:
        "/dashboard/discovery/cloudconfiguration/select-plateform/add-configuration",
    },
    {
      id: 3,
      title: "Azure",
      commingsoon:true,
      description: "Discover resources across your Azure subscriptions.",
      imageURL: AzureLogo,
      link:
        "/dashboard/discovery/cloudconfiguration/select-plateform/add-configuration",
    },
   
  ];
  return cards;
};